import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./index.scss";
import { setSelectedContent } from "../../module/content/content.action";
import $ from 'jquery';
import { CONFIG } from "../../config/constant";
import { translation } from '../../i18';

const ListContainer = (props) => {
  const { t } = translation();
  const dispatch = useDispatch();
  const [listData, setListData] = useState([]);
  const isSearch = useRef(false);
  const { contentDetail,contents, searchList } = useSelector((state) => state.content);
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (searchList?.length) {
      isSearch.current=true;
      getContentDetails(searchList?.[0]);
      setListData(searchList);
    } else if (contents?.length) {
      isSearch.current=false;
      getContentDetails(contents?.[0]);
      setListData(contents)
    }
  }, [contents, searchList]);

  async function getContentDetails(content) {
    const url = CONFIG.BASE_URL + `app/content/${content?._id}`;
    let response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token
      },
    });
    if (response && response.status === 200) {
      response = await response.json();
      dispatch(setSelectedContent(response));
    }
  }

  function reloadOwl() {
    $(function () {
      var owl = $(".owl-carousel");
      owl.owlCarousel({
        items: 1,
        margin: 10,
        loop: false,
        nav: true
      });
    });

  }

  const clickHandler = (e, item) => {
    getContentDetails(item);
  };
  return (
    <>
      {(isSearch.current && listData?.length)||(!isSearch.current && listData?.length>1) ? <div className={`list-container`}  >
        {/* <span className="left-arrow"></span> */}
        <div className="list-wrapper">
          <h3 className="list-title">{searchList.length ? t('searchResults') : t('moreMovies')}</h3>
          <ul className={`list owl-carousel ${listData?.length == 1 ? 'transparent' : ''}`}>
            {listData?.map(item => {
              return (<li className={`list-item ${contentDetail?._id==item?._id?'active':''}`} key={item?._id} style={{ backgroundImage: `URL('${item?.thumbnail}')` }} onClick={(e) => clickHandler(e, item)}></li>)
            })}
          </ul>
        </div>
        {/* <span className="right-arrow"></span> */}
      </div> : null}
    </>
  );
};

export default React.memo(ListContainer);
